import PropTypes from "prop-types"
import { safeDivide } from "helpers/math"

function ChartDefs({ lines, pathsId, axisId, offset, chartWidth = 0 }) {
  const gradientsOffset = `${safeDivide(offset, chartWidth) * 100}%`
  const defs = lines.map((line, index) =>
    <linearGradient key={index} id={`${pathsId}-${index}`} gradientUnits="userSpaceOnUse" x1="0" y1="0" x2={chartWidth} y2="0">
      <stop offset={gradientsOffset} style={{ stopColor: line.style.stroke }} />
      <stop offset={gradientsOffset} className="selected-path-end" />
    </linearGradient>,
  )

  return <defs>
    {defs}
    <linearGradient id={axisId} gradientUnits="userSpaceOnUse" x1="0" y1="0" x2={chartWidth} y2="0">
      <stop offset={gradientsOffset} className="selected-axis-start" />
      <stop offset={gradientsOffset} className="selected-axis-end" />
    </linearGradient>
  </defs>
}

ChartDefs.propTypes = {
  pathsId: PropTypes.string.isRequired,
  axisId: PropTypes.string.isRequired,
  lines: PropTypes.array.isRequired,
  offset: PropTypes.number,
  chartWidth: PropTypes.number,
}

export default ChartDefs
